import { render, staticRenderFns } from "./ClaimMoneyInput.vue?vue&type=template&id=77997c08"
import script from "./ClaimMoneyInput.vue?vue&type=script&lang=js"
export * from "./ClaimMoneyInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports